// services/Deliverable.js
import BaseStrapiCollection from "../base-strapi-collection/base-strapi-collection";
import qs from "qs";

export default class Chat extends BaseStrapiCollection {
    static kind = "collectionType";
    static singularName = "chat";
    static pluralName = "chats";
    static displayName = "Chat";

    constructor() {
        super(`${Chat.kind}`,`${Chat.singularName}`,`${Chat.pluralName}`);}

    async getAll(query = {}) {
        const qs = require('qs');
        const _query = qs.stringify({...query}, {
            encodeValuesOnly: true, // prettify URL
        });

        return await this.fetch(_query);
    }


    async getById(id, query = {}) {
        return await this.find(id, { populate: "*", ...query });
    }

    async createItem(data) {
        return await this.create(data);
    }

    async updateItem(id, data) {
        return await this.update(id, data);
    }

    async deleteItem(id) {
        return await this.delete(id);
    }
}
